<nb-menu autoCollapse="true" [items]="items"></nb-menu>
